import {
    WGCWX_BATTLE_SCHEDULE_REQUEST,
    WGCWX_BATTLE_SCHEDULE_SUCCESS,
    WGCWX_BATTLE_SCHEDULE_ERROR,
} from 'state/actions/wgcwx_battle_schedule'

const defaultState = {
    isInitialLoading: true,
    errorMessage: null,
    battleSchedule: [],
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
    case WGCWX_BATTLE_SCHEDULE_REQUEST: {
        return {
            ...state,
            errorMessage: null,
        }
    }
    case WGCWX_BATTLE_SCHEDULE_SUCCESS: {
        return {
            ...state,
            isInitialLoading: false,
            battleSchedule: action.payload.battleSchedule,
        }
    }
    case WGCWX_BATTLE_SCHEDULE_ERROR: {
        return {
            ...state,
            isInitialLoading: true,
            errorMessage: action.payload.errorMessage,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/wgcwx_battle_schedule.js